import styled from "styled-components";
import { Container } from "react-grid-system";

import coinbase_bg from "../../img/get-dag/coinbase_bg.png";
import stargazer_bg from "../../img/get-dag/stargazer_bg.png";

export const GetDagContainer = styled(Container)`
  width: 100%;
  max-width: 1024px;
`;

export const FirstSection = styled.section`
  padding-top: 64px;
  width: 100%;
  background-image: url(${coinbase_bg});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;

  p {
    padding: 0px;
  }

  & > div { //ImageTextV2
    gap: 16px;
    & > div:nth-child(1) {
      @media ${(props) => props.theme.breakpoints && props.theme.breakpoints.sm} {
        label {
          // font-size: 40px;
        }
      }
    }

    & > div:nth-child(2) {
      margin-right: -24px;
      justify-content: flex-end;

      @media ${(props) => props.theme.breakpoints && props.theme.breakpoints.sm} {
        margin-right: 0px;
        margin: auto;
        justify-content: center;
      }
    }
  }

`;

export const StargazerSection = styled.section`
  width: 100%;
  background-image: url(${stargazer_bg});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;

  p {
    padding: 0px;
  }

  & > div { //ImageTextV2
    gap: 16px;
    & > div:nth-child(2) {
      margin-left: -24px;
      justify-content: flex-start;

      @media ${(props) => props.theme.breakpoints && props.theme.breakpoints.sm} {
        margin-right: 0px;
        margin: auto;
        justify-content: center;

        padding-top: 24px;
        padding-bottom: 24px;
      }
    }
  }
`;

export const SecondSection = styled.section`
  width: 100%;
  padding-top: 64px;
  position: relative;
  display: flex;
  justify-content: center;
  z-index: 490;
`;

export const ThirdSection = styled.section`
  width: 100%;
  position: relative;
  display: flex;
  justify-content: center;
  z-index: 490;
  padding-top: 48px;
  padding-bottom: 48px;
  @media ${(props) => props.theme.breakpoints && props.theme.breakpoints.lg} {
    padding-left: 24px;
    padding-right: 24px;
  }

  @media ${(props) => props.theme.breakpoints && props.theme.breakpoints.sm} {
    padding-top: 24px;
    padding-bottom: 24px;
  }
`;

export const SimplexContainer = styled.div`
  max-width: 1024px;
  margin: 50px 0px;
  width: 100%;
  height: 500px;
  display: flex;
  justify-content: space-around;
  position: relative;

  @media ${(props) => props.theme.breakpoints && props.theme.breakpoints.tablet} {
    flex-direction: column;
  }

  > div {
    h1 {
      position: absolute;
      z-index: 490;
      color: #fff;

      font-weight: 400;
      font-size: 42px;
      line-height: 44px;
      top: 50px;
      left: 10%;
      max-width: 150px;

      @media ${(props) => props.theme.breakpoints && props.theme.breakpoints.tablet} {
        position: relative;
      }
    }

    img {
      position: absolute;
      width: 900px;
      z-index: 0;
      top: -300px;
      left: -300px;

      @media ${(props) => props.theme.breakpoints && props.theme.breakpoints.tablet} {
        width: 90%;
        height: 90%;
        left: -20%;
        top: -30%;
      }

      @media ${(props) => props.theme.breakpoints && props.theme.breakpoints.mobile} {
        width: 120%;
        left: -20%;
        top: -30%;
      }
    }
  }
`;

export const SimplexWidget = styled.div`
  position: relative;
  z-index: 400;
  right: 0%;
  width: 40%;

  @media ${(props) => props.theme.breakpoints && props.theme.breakpoints.tablet} {
    top: 100px;
    width: 100%;
  }
`;

export const FourthSection = styled.section`
  width: 100%;
  position: relative;
  z-index: 100;
  margin: 50px 0px;
  display: flex;
  justify-content: center;

  > div {
    padding-left: 10%;
    width: 60%;
    min-height: 200px;
    background: rgba(255, 255, 255, 0.02);
    border-radius: 8px;
    display: flex;
    align-items: center;

    p {
      font-size: 16px;
      line-height: 20px;
      color: #fff;
      margin-left: 5%;
      max-width: 70%;

      @media ${(props) => props.theme.breakpoints && props.theme.breakpoints.tablet} {
        margin-left: 10%;
      }
    }
    img {
      @media ${(props) => props.theme.breakpoints && props.theme.breakpoints.tablet} {
        margin-left: 5%;
      }
    }

    @media ${(props) => props.theme.breakpoints && props.theme.breakpoints.tablet} {
      padding: 30px 0px;
      width: 90%;
    }
  }

  @media ${(props) => props.theme.breakpoints && props.theme.breakpoints.tablet} {
    margin: 20vh 0px 0px;
  }
`;

export const FifthSection = styled.section`
  width: 100%;
  margin: 96px 0px 100px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  padding-left: 24px;
  padding-right: 24px;

  @media ${(props) => props.theme.breakpoints && props.theme.breakpoints.tablet} {
    width: 100%;
    flex-direction: column;
    margin-top: 48px;
    margin-bottom: 96px;
  }

  > div {
    @media ${(props) => props.theme.breakpoints && props.theme.breakpoints.tablet} {
      margin-left: 0px;
    }
  }
`;

export const DescriptionContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  
  span {
    font-size: 15px;
    line-height: 30px;
    color: #fff;
    font-weight: 500;
    font-family: "Inter";
  }

  h1 {
    text-align: center;
    font-weight: 400;
    font-size: 48px;
    font-family: "everettmedium";
    line-height: 62px;
    color: #D9E0FD;
    letter-spacing: -0.8px;

    @media ${(props) => props.theme.breakpoints && props.theme.breakpoints.sm} {
      font-size: 32px;
      line-height: 64px;
    }
  }
`;

export const CardsContainer = styled.div`
  max-width: 1174px;
  width: 100%;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-gap: 30px 32px;

  @media ${(props) => props.theme.breakpoints && props.theme.breakpoints.tablet} {
    grid-template-columns: 1fr 1fr;
  }

  @media ${(props) => props.theme.breakpoints && props.theme.breakpoints.mobile} {
    grid-template-columns: 1fr;
  }
`;

export const CustomCard = styled.div`
  width: 100%;
  height: 265px;

  display: flex;
  flex-direction: column;
  padding: 41px 0px 0px 40px;

  background: rgba(255, 255, 255, 0.02);
  border: 0.5px solid #272B37;
  border-radius: 8px;

  img, svg {
    width: 60px;
    height: 60px;
  }

  strong {
    font-style: normal;
    font-weight: 500;
    font-size: 18px;
    line-height: 22px;

    color: #FFFFFF;
    margin-top: 22px;
  }

  p {
    font-style: normal;
    font-weight: 30;
    font-size: 16px;
    line-height: 19.2px;

    color: #B6B9C8;
    margin-top: 10px;
    padding-right: 10px;
    height: 75px;
  }

  @media ${(props) => props.theme.breakpoints && props.theme.breakpoints.mobile} {
    height: 300px;
    width: auto;
    strong {
      padding-right: 30px;
    }

    p {
      margin-bottom: 20px;
      padding-right: 30px;
    }
  }

  @media ${(props) => props.theme.breakpoints && props.theme.breakpoints.smallMobile} {
    height: 400px;
  }
`;
